<template>
  <label ref="label" class="switch" :class="[size, { 'is-disabled': disabled }]" :disabled="disabledAttr" :tabindex="disabled ? false : 0" @keydown.prevent.enter.space="$refs.label.click()" @mousedown="isMouseDown = true" @mouseup="isMouseDown = false" @mouseout="isMouseDown = false" @blur="isMouseDown = false">
    <input v-model="computedValue" type="checkbox" :disabled="disabledAttr" :name="name" :value="nativeValue" :true-value="trueValue" :false-value="falseValue" @click.stop>
    <span class="check" :class="[{ 'is-elastic': isMouseDown && !disabled }, checkClasses]" />
    <span class="control-label">
      <slot /></span>
  </label>
</template>

<script>
/**
* @displayName Switch
*/

  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'DSwitch',
    status: 'prototype',
    release: '0.1.1',
    props: {
      modelValue: [String, Number, Boolean, Function, Object, Array, Symbol],
      nativeValue: [String, Number, Boolean, Function, Object, Array, Symbol],
      disabled: Boolean,
      color: {
        type: String,
        default: 'primary-500',
      },
      name: String,
      size: String,
      trueValue: {
        type: [String, Number, Boolean, Function, Object, Array, Symbol],
        default: true,
      },
      falseValue: {
        type: [String, Number, Boolean, Function, Object, Array, Symbol],
        default: false,
      },
      multiple: {
        type: Boolean,
        default: null,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        isMouseDown: false,
      };
    },

    computed: {
      disabledAttr() {
        return this.disabled ? true : null;
      },
      computedValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },

      checkClasses() {
        return {
          [`bg-${this.color}`]: this.checkedValue,
        };
      },

      checkedValue() {
        let result = false;
        if (Array.isArray(this.computedValue)) {
          result = this.computedValue.filter((item) => item === this.nativeValue).length > 0;
        } else {
          result = this.computedValue;
        }

        return result;
      },
    },
  });
</script>